/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
} from "reactstrap";
import {version} from "version";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: !!localStorage.getItem('jwt_auth_token'),
      user: {},
    }
  }

  onKeyUp(e) {
    var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
    if (charCode === 13) {
      this.handleLogin()
    }
  }

  handleLogin() {
    const body = { ...this.state.user, source: 'pos' };

    fetch(process.env.REACT_APP_API_URL + '/login', {
      method: 'POST',
      body: JSON.stringify(body)
    })
        .then(res => res.json())
        .then((data) => {
          if (data.header.status_code !== 200) {
            return this.setState({ errorMessage: 'Username atau password tidak sesuai.' })
          }
          if (data.data.change_password === true) {
            localStorage.setItem('username', this.state.user.username);
            return this.setState({ redirectToForgotPassword: true });
          }
          localStorage.setItem('username', this.state.user.username)
          localStorage.setItem('jwt_auth_token', data.data.jwt_auth_token)
          localStorage.setItem('user_id', jwtDecode(data.data.jwt_auth_token).user_id)
          localStorage.setItem('user_roles', jwtDecode(data.data.jwt_auth_token).user_roles)
          localStorage.setItem('login_time', new Date())
          localStorage.setItem('warehouse_id', jwtDecode(data.data.jwt_auth_token).warehouse_id)

          return this.setState({ isLoggedIn: true });
        })
  }

  handleInputChanged(e) {
    let nam = e.target.name
    let val = e.target.value
    this.setState(prevState => {
      let user = Object.assign({}, prevState.user);
      user[nam] = val;
      return { user };
    })
}

  render() {
    console.log(version)
    if (this.state.isLoggedIn) {
      return <Redirect to="/" />;
    }
    if (this.state.redirectToForgotPassword) {
      return <Redirect to="/auth/forgot-password" />;
    }

    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <small>Masuk dengan kredensial anda</small>
              </div>
              {this.state.errorMessage && (
                <Alert color="danger">
                  {this.state.errorMessage}
                </Alert>
              )}
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-satisfied" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Username"
                      type="text"
                      name="username"
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type="password"
                      name="password"
                      onKeyUp={this.onKeyUp.bind(this)}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                  />
                </div>
                <div className="text-center">
                  <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    onClick={() => this.handleLogin()}>
                    Sign in
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
};

export default Login;
